import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default {
    unix2datetime(unix, format = 'YYYY-MM-DD HH:mm') {
        let d = dayjs.unix(unix);
        return d.isValid() ? d.format(format) : '';
    },
    formatDate(dt, format='YYYY-MM-DD'){
        return dayjs.utc(dt).format(format);
    },
    str2date(s) {
        let d = dayjs.utc(s);
        return d.isValid() ? d.format('YYYY-MM-DD') : '';
    },
    todayStr(format = 'YYYY-MM-DD') {
        return dayjs().format(format);
    },
    thisMonthStr(format = 'YYYY-MM') {
        return dayjs().format(format);
    },
    blank2Null(obj){
        let result = Object.assign({}, obj);
        Object.keys(result).forEach(key=>{
            if(result[key]===''){
                result[key]=null;
            }
        });
        return result;
    }
};
